import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Gift, ArrowLeft, TrendingUp, TrendingDown, RotateCcw } from "lucide-react";
import { api, inr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const TYPE = {
  earn: { label: "Earned", cls: "text-emerald-600", Icon: TrendingUp },
  redeem: { label: "Redeemed", cls: "text-amber-600", Icon: TrendingDown },
  refund: { label: "Refunded", cls: "text-sky-600", Icon: RotateCcw },
  clawback: { label: "Reversed", cls: "text-red-500", Icon: TrendingDown },
};

export default function PointsHistory() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { if (user === false) nav("/login?next=/rewards"); }, [user]);
  useEffect(() => { if (user) api.get("/loyalty/ledger").then((r) => setD(r.data)).catch(() => setD({ entries: [] })); }, [user]);
  if (!user || !d) return <div className="max-w-2xl mx-auto py-24 text-center text-slate-400">Loading…</div>;

  return (
    <div className="max-w-2xl mx-auto px-4 py-6 space-y-5">
      <button onClick={() => nav("/profile")} className="flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-slate-700"><ArrowLeft size={16} /> Back to profile</button>

      <div className="rounded-2xl p-5 text-white bg-gradient-to-br from-emerald-600 to-emerald-700" data-testid="points-history-header">
        <p className="text-emerald-100 text-xs font-semibold uppercase tracking-wider flex items-center gap-1.5"><Gift size={13} /> Reward Points Balance</p>
        <p className="text-4xl font-extrabold mt-1">{d.balance} pts</p>
        <p className="text-emerald-100 text-sm">Worth {inr(d.wallet_value)} at checkout · 1 pt = {inr(d.config?.redeem_value_per_point)}</p>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 overflow-hidden">
        <div className="px-5 py-3 border-b border-slate-100 font-bold">Points History</div>
        {!d.entries?.length ? (
          <p className="text-center py-12 text-slate-400 text-sm" data-testid="points-empty">Abhi koi points activity nahi. Order karo aur delivery par points kamao 🎁</p>
        ) : (
          <div className="divide-y divide-slate-50">
            {d.entries.map((e) => {
              const t = TYPE[e.type] || TYPE.earn;
              return (
                <div key={e.id} data-testid={`ledger-${e.id}`} className="flex items-center justify-between px-5 py-3">
                  <div className="flex items-center gap-3">
                    <div className={`w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center ${t.cls}`}><t.Icon size={15} /></div>
                    <div>
                      <p className="font-semibold text-sm">{t.label}{e.order_no ? ` · ${e.order_no}` : ""}</p>
                      <p className="text-xs text-slate-400">{(e.created_at || "").slice(0, 10)}</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className={`font-bold text-sm ${e.points >= 0 ? "text-emerald-600" : "text-red-500"}`}>{e.points >= 0 ? "+" : ""}{e.points} pts</p>
                    <p className="text-xs text-slate-400">Bal: {e.balance_after} pts</p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
